import { useNavigate } from "react-router-dom";
import { useState } from "react";

const HistoryComp = (props) => {
  const navigate = useNavigate();
  const [isExpanded, setIsExpanded] = useState(false);

  {console.log(props)}

  const handleToggle = () => {
    setIsExpanded((prevState) => !prevState);
  };

  // Helper function to parse points
  const parsePoints = (text) => {
    console.log(text)
    // Split by bullet or newline
    const points = text
      .split(/\n|•/g)
      .map((point) => point.trim())
      .filter((point) => point !== "");
    return points;
  };

  // Handle heading truncation
  const renderHeading = () => {
    if (props.heading && typeof props.heading === "string") {
      if (isExpanded || props.heading.length <= 200) {
        return props.heading;
      }
      return `${props.heading.slice(0, 200)}...`;
    }
    return <span className="text-gray-500">No User Input Available</span>;
  };

  // Handle description truncation
  const renderDescription = () => {
    if (props.desc && typeof props.desc === "string") {
      const points = parsePoints(props.desc);
      const joinedPoints = points.join(" ");
      if (isExpanded || joinedPoints.length <= 300) {
        return (
          <ul className="list-disc pl-5 space-y-2">
            {points.map((point, index) => (
              <li key={index}>{point}</li>
            ))}
          </ul>
        );
      }
      // Show truncated version
      let truncated = joinedPoints.slice(0, 300);
      // Cut off at last full word if possible
      const lastSpace = truncated.lastIndexOf(" ");
      if (lastSpace > 0) {
        truncated = truncated.slice(0, lastSpace);
      }
      truncated = `${truncated}...`;
      return (
        <p className="text-gray-700 text-sm leading-relaxed">
          {truncated}
        </p>
      );
    }
    return <span className="text-gray-500">No Bot Response Available</span>;
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg shadow-lg p-4 mb-4 w-full max-w-3xl mx-auto hover:shadow-xl transition duration-200 ease-in-out">
      {/* Heading Section */}
      <div className="mb-4">
        <h3 className="text-lg font-semibold text-gray-800">
          {renderHeading()}
        </h3>

        {/* Read More/Read Less Button for Heading */}
        {props.heading && typeof props.heading === "string" && props.heading.length > 200 && (
          <button
            className="mt-2 text-sm text-blue-600 hover:text-blue-800 transition font-medium"
            onClick={handleToggle}
          >
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>

      {/* Description Section */}
      <div className="text-gray-700 text-sm leading-relaxed">
        {renderDescription()}
        {/* Read More/Read Less Button for Description */}
        {props.desc && typeof props.desc === "string" && props.desc.length > 300 && (
          <button
            className="mt-2 text-sm text-blue-600 hover:text-blue-800 transition font-medium"
            onClick={handleToggle}
          >
            {isExpanded ? "Read Less" : "Read More"}
          </button>
        )}
      </div>
    </div>
  );
};

export default HistoryComp;
